import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const application = Application.start();

// Configure Stimulus development experience
application.warnings = true;
application.debug = process.env.NODE_ENV === "development";
window.Stimulus = application;

// Automatically load controllers from ViewComponents directory.
const context = require.context(
  "../../components/",
  true,
  /(.*)\/.+_controller\.js$/
);

Stimulus.load(definitionsFromContext(context));

export { application };

///////////////////////
// This was the pre 3.0 config, with no separate index.js manifest
// I'm not sure if we need the more manual approach of having to update
// the index.js manifest for each new controller
// import { Application } from "@hotwired/stimulus"
// import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// window.Stimulus = Application.start()
// const context = require.context("./controllers", true, /\.js$/)
// Stimulus.load(definitionsFromContext(context))
